// This file is automatically generated during build
// DO NOT EDIT MANUALLY

export interface AppVersion {
  version: string;
  buildTime: string;
  buildNumber?: string;
  gitCommit?: string;
  gitBranch?: string;
}

// Version info generated at build time

export const APP_VERSION: AppVersion = {
  version: '0.3.25.1093',
  buildTime: '2026-11-02T16:16:30.989Z',
  buildNumber: '1093',
  gitCommit: 'ad1aa96d632b2122bdced5d8fad5fdc14c5a497d',
  gitBranch: 'main',
};

export const VERSION_STORAGE_KEY = 'notego_app_version';
export const LAST_VERSION_KEY = 'notego_last_version';
